<template>
  <div class="bg-grey py-5">
    <div
      v-if="isRegistrationMandatory || (isMyKwsAccountMandatory && isLoggedIn)"
      class="kws-int-container">
      <p
        class="error-box mb-4"
        v-if="alreadyRegistered && !isCurrentUserStatusCanceled"
        v-text="translate('lblAlreadyRegistered')"
      ></p>
      <p
        class="error-box mb-4"
        v-if="isEventFullyBooked && !alreadyRegistered"
        v-text="translate('lblNoCapacity')"
      ></p>
      <div
        class="event-registration"
        v-if="Object.keys(event).length !== 0 && hasCampaignIDParam"
      >
        <h3
          class="h3 bold mb-4"
          v-text="formatDate(event.startDate, formatStartDate)"
        ></h3>
        <div class="title-row d-flex justify-content-between">
          <h1 class="h1 mr-5" v-text="event.name"></h1>
          <EventCrops :event-crops="event.crops" :is-big="true"></EventCrops>
        </div>
        <div v-if="registrationSuccessful && isAnyRegistrationSuccessfulTextPresent">
          <p
            v-if="translations.lblRegistrationSuccessful"
            v-text="translate('lblRegistrationSuccessful')">
          </p>
          <div
            v-if="translations.lblRegistrationSuccessfulFormatted && isLoggedIn"
            v-html="translate('lblRegistrationSuccessfulFormatted')"
          ></div>
        </div>
        <div v-if="registrationSuccessfulWaiting && isAnyRegistrationSuccessfulWaitingTextPresent">
          <p
            v-if="translations.lblRegistrationSuccessfulWaiting"
            v-text="translate('lblRegistrationSuccessfulWaiting')">
          </p>
          <div
            v-if="translations.lblRegistrationSuccessfulWaitingFormatted && isLoggedIn"
            v-html="translate('lblRegistrationSuccessfulWaitingFormatted')"
          ></div>
        </div>
        <div
          class="event-body"
          v-if="!registrationSuccessful && !registrationSuccessfulWaiting && !isCurrentUserStatusCanceled"
        >
          <img
            v-if="event.additionalImage"
            class="mb-4"
            :src="event.additionalImage.src"
            :alt="event.additionalImage.alt"
            :srcset="event.additionalImage.srcset"
            :sizes="event.additionalImage.sizes"
          />
          <div class="introduction" v-html="translate('lblIntroduction')"></div>
          <form @submit.prevent="submitForm" class="no-validate">
            <div class="row" v-for="(row, i) in formFields" :key="i">
              <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
              <div class="col-m mb-3" v-for="(field, j) in row" :key="j">
                <div
                  class="floating-input-label"
                  v-if="field.type === 'select'"
                >
                  <select
                    :class="['floating-input-label__select']"
                    :name="field.name"
                    :id="field.name"
                    :required="field.required"
                    :identifier="field.identifier"
                    v-model="fields[field.identifier]"
                    :disabled="alreadyRegistered || isSubmitting"
                    @change="triggerChange"
                    @blur="validateInput"
                  >
                    <option value="" :selected="!value"></option>
                    <option
                      v-for="(option, k) in field.options"
                      :key="k"
                      :value="option.value"
                      :selected="option.value === field.value"
                      v-text="option.label"
                    ></option>
                  </select>
                  <label
                    class="floating-input-label__label"
                    v-text="placeholder(field)"
                    :for="field.name"
                  ></label>
                </div>
                <div
                  class="floating-input-label"
                  v-else-if="field.type === 'multi'"
                >
                  <input-multiselect
                    :fatData="field"
                    :options="field.options"
                    :placeholder="placeholder(field)"
                    :identifier="field.identifier"
                    :name="field.name"
                    :label="placeholder(field)"
                    :required="field.required"
                    @stringedValue="addMultiselectValue"
                    :disabled="alreadyRegistered || isSubmitting"
                    @changed="validateForm"
                  >
                  </input-multiselect>
                </div>
                <div class="floating-input-label" v-else>
                  <input
                    @keyup="validateInput"
                    @blur="validateInput"
                    :type="field.type"
                    class="floating-input-label__input"
                    :name="field.name"
                    :id="field.name"
                    :placeholder="placeholder(field)"
                    :required="field.required"
                    :identifier="field.identifier"
                    v-model="fields[field.identifier]"
                    :disabled="alreadyRegistered || isSubmitting"
                  />
                  <label
                    class="floating-input-label__label"
                    v-text="placeholder(field)"
                    :for="field.name"
                  ></label>
                </div>
              </div>
            </div>
            <div class="row" v-if="isParticipantsModuleActiveForThisProject && isLoggedIn">
              <div class="col">
                <input class="f-checkbox" id="f-checkbox-permission-for-show-user-data-in-participants-list" name="keepLoggedIn" type="checkbox" v-model="isPermissionForShowUserDataInParticipantListSet" @change="validateForm" required :disabled="alreadyRegistered || isSubmitting">
                <label for="f-checkbox-permission-for-show-user-data-in-participants-list" class="f-label">
                  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" class="svg-icon svg-icon--checkbox"><path class="svg-icon svg-icon__default" d="M0 0h20v20H0z"></path><path class="svg-icon svg-icon__checked" d="M7.784 16.85l-4.49-5.07c-.464-.532-.372-1.273.23-1.69.58-.416 1.436-.324 1.9.21l2.267 2.568 6.853-8.38c.44-.532 1.297-.648 1.9-.254.6.393.74 1.157.3 1.69L7.783 16.85z"></path></svg>
                  <span v-html="translate('lblPermissionTextForShowUserDataInParticipantsList')"></span>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <button
                  class="button button--medium button--primary mt-3"
                  v-text="registrationLinkText"
                  :disabled="alreadyRegistered || isSubmitting || !formValid"
                ></button>
              </div>
            </div>
          </form>
        </div>
        <div class="row" v-if="isCurrentUserStatusCanceled && !registrationSuccessful && !registrationSuccessfulWaiting">
          <div class="col">
            <div class="introduction" v-html="translate('lblRejoinIntroduction')"></div>
            <div class="row" v-if="isParticipantsModuleActiveForThisProject">
              <div class="col">
                <input class="f-checkbox" id="f-checkbox-permission-for-show-user-data-in-participants-list" name="keepLoggedIn" type="checkbox" v-model="isPermissionForShowUserDataInParticipantListSet" @change="validateForm" required>
                <label for="f-checkbox-permission-for-show-user-data-in-participants-list" class="f-label">
                  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" class="svg-icon svg-icon--checkbox"><path class="svg-icon svg-icon__default" d="M0 0h20v20H0z"></path><path class="svg-icon svg-icon__checked" d="M7.784 16.85l-4.49-5.07c-.464-.532-.372-1.273.23-1.69.58-.416 1.436-.324 1.9.21l2.267 2.568 6.853-8.38c.44-.532 1.297-.648 1.9-.254.6.393.74 1.157.3 1.69L7.783 16.85z"></path></svg>
                  <span v-html="translate('lblPermissionTextForShowUserDataInParticipantsList')"></span>
                </label>
              </div>
            </div>
            <button
              class="button button--medium button--primary mt-3"
              v-text="translate('lblRejoin')"
              :disabled="isParticipantsModuleActiveForThisProject && !isPermissionForShowUserDataInParticipantListSet"
              @click="rejoinEvent"
            ></button>
          </div>
        </div>
      </div>
    </div>
      <div
        class="kws-int-container"
        v-if="isMyKwsAccountMandatory && !isLoggedIn" >
          <div v-html="translations.lblLoginMandatoryHint" class="mb-3"></div>
          <a
            @click.prevent="redirectToLogin"
            v-text="translations.lblLandingPageUrlButton"
            class="button button--medium button--primary"
          >
          </a>
      </div>
    <notification-modal
      v-if="error"
      type="error"
      :title="translate('lblErrorRegistrationTitle')"
      :subtitle="error.subtitle"
      :content="error.content"
      :prevent-close="true"
      @close="error = false"
      @okay="error = false"
    ></notification-modal>
    <loading-indicator
      v-if="(loading || isSubmitting) && !error"
    ></loading-indicator>
  </div>
</template>

<script>
import EventCrops from '@/events/components/event-crops.vue';
import EventRegistrationMixin from './mixins/EventRegistrationMixin';
import NotificationModal from '../shared/components/NotificationModal.vue';
import LoadingIndicator from '../shared/components/loading-indicator.vue';
import InputMultiselect from '../shared/components/input-multiselect.vue';
import EventPermissionsMixin from './mixins/EventPermissionsMixin';
import EventType from './types/EventTypes';

export default {
  name: 'EventRegistration',
  data: () => ({
    hasCampaignIDParam: false,
    event: {},
    fields: {},
    error: null,
    registrationSuccessful: false,
    registrationSuccessfulWaiting: false,
    alreadyRegistered: false,
    isSubmitting: false,
    formValid: false,
    isPermissionForShowUserDataInParticipantListSet: false,
    loading: false,
    multiselectValues: [],
    isCurrentUserStatusCanceled: false,
    userID: '',
  }),
  components: {
    EventCrops,
    InputMultiselect,
    NotificationModal,
    LoadingIndicator,
  },
  props: {
    translations: Object,
    formFields: Array,
    apiUrl: {
      type: String,
      required: true,
    },
    formatStartDate: {
      type: String,
      required: true,
    },
    value: String,
    landingpageUrl: {
      type: String,
      required: true,
    },
  },
  mixins: [EventRegistrationMixin, EventPermissionsMixin],
  computed: {
    isAnyRegistrationSuccessfulTextPresent() {
      return this.translations.lblRegistrationSuccessful || this.translations.lblRegistrationSuccessfulFormatted;
    },
    isAnyRegistrationSuccessfulWaitingTextPresent() {
      return this.translations.lblRegistrationSuccessfulWaiting || this.translations.lblRegistrationSuccessfulWaitingFormatted;
    },
    isLoggedIn() {
      return !!window.KWS && !!window.KWS.user;
    },
  },
  methods: {
    async checkForRegistrationStatus() {
      if (this.event.eventType === EventType.EVENT_WITH_MY_KWS_REGISTRATION) {
        const responseParticipating = await this.getEventsParticipating();
        const registeredEventObject = responseParticipating.data.info.Campaigns.find(
          (campaign) => campaign.Id === this.event.id,
        );

        const eventRegistrationStatus = registeredEventObject.CampaignMembers[0].EventRegistrationStatus__c;

        if (eventRegistrationStatus === 'Waiting') {
          this.registrationSuccessfulWaiting = true;
        } else {
          this.registrationSuccessful = true;
        }
      } else {
        this.registrationSuccessful = true;
      }
    },
    finishSubmitting() {
      this.isSubmitting = false;
    },
    handleRegistrationError(err) {
      this.error = {
        subtitle: this.translate('lblApiErrorRegistrationSubtitle'),
      };
      console.error(err.message);
    },
    async sendEventRegistrationRequest() {
      const data = {};

      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.fields) {
        if (Object.hasOwnProperty.call(this.fields, key)) {
          const element = this.fields[key];
          data[key] = { value: element };
        }
      }
      this.multiselectValues.forEach((x) => {
        data[x.identifier] = { value: x.value };
      });
      this.formFields.flat(2).forEach((x) => {
        Object.entries(data).forEach((item) => {
          if (x.name === item[0] || x.identifier === item[0]) {
            if (x.descriptionIdentifier) {
              data[x.descriptionIdentifier] = { value: x.description };
            }
          }
        });
      });

      const payload = {
        ...data,
        Registered_Participants__c: {
          value: '1',
        },
        CountryCode: {
          value: this.isLoggedIn ? window.KWS.user.profile.address.country.toLowerCase() : document.documentElement.getAttribute('lang'),
        },
      };

      return this.$http({
        method: 'post',
        url: this.event.eventType ? `${this.apiUrl}/campaign/events/event/${this.event.eventType}/${this.event.id}` : `${this.apiUrl}/campaign/events/event/${this.event.id}`,
        headers: {
          Authorization: `${this.getCookieValue('Authorization')}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(payload),
      })
        .then(this.checkForRegistrationStatus)
        .catch(this.handleRegistrationError)
        .finally(this.finishSubmitting);
    },
    addMultiselectValue(obj) {
      const data = obj.value.toString().replace(/,/gi, ';');
      obj.value = data;
      const objIndex = this.multiselectValues.findIndex(
        (x) => x.identifier === obj.identifier,
      );

      if (objIndex !== -1) {
        if (data.length > 0) {
          this.multiselectValues[objIndex].value = data;
        } else {
          this.multiselectValues = this.multiselectValues.filter(
            (x) => x.identifier !== obj.identifier,
          );
        }
      } else {
        this.multiselectValues.push(obj);
      }
    },
    validateInput(e) {
      e.target.classList.toggle('user-error', !e.target.validity.valid);
      this.validateForm();
    },
    async validateForm() {
      const requiredFields = [...document.querySelectorAll(':required')];
      if (!requiredFields.length) return;
      if ([...document.querySelectorAll('.multiselect.required')].length) {
        this.formValid = (await requiredFields.every((input) => input.validity.valid))
          && [...document.querySelectorAll('.multiselect.required')].every(
            (select) => select.getAttribute('selected-amount') !== '0',
          );
      } else {
        this.formValid = requiredFields.every((input) => input.validity.valid);
      }
    },
    prefillFieldsWithUserData() {
      if (!window?.KWS?.user) return;

      this.fields.FirstName__c = window.KWS.user.profile?.firstname || '';
      this.fields.LastName__c = window.KWS.user.profile?.lastname || '';
      this.fields.Street__c = window.KWS.user.profile?.address?.street || '';
      this.fields.PostalCode__c = window.KWS.user.profile?.address?.zip?.trim() || '';
      this.fields.City__c = window.KWS.user.profile?.address?.city || '';
      this.fields.Mobile__c = window.KWS.user.profile?.address?.phone
        || window.KWS.user.profile?.address?.mobile
        || '';
      this.fields.Email__c = window.KWS.user.account?.email || '';
    },
    async submitForm() {
      this.isSubmitting = true;
      const requests = this.isLoggedIn ? [
        this.setPermissionsForShowUserDataInParticipantsList(this.event.id, this.isPermissionForShowUserDataInParticipantListSet),
        this.sendEventRegistrationRequest(),
      ] : [this.sendEventRegistrationRequest()];
      await Promise.all(requests);
    },
    async getEventsParticipating() {
      return this.getEventData(`${this.apiUrl}/campaign/events/participating/`);
    },
    triggerChange(event) {
      event.target.classList.remove('filled');

      if (event.target.value && event.target.value !== '') {
        event.target.classList.add('filled');
      }
      this.validateInput(event);
      this.validateForm();
    },
    async rejoinEvent() {
      this.isSubmitting = true;
      await Promise.all([
        this.setPermissionsForShowUserDataInParticipantsList(this.event.id, this.isPermissionForShowUserDataInParticipantListSet),
        this.sendEventRejoinRequest(),
      ]);
    },
    async sendEventRejoinRequest() {
      const payload = {
        Cancelled__c: {
          value: false,
        },
        CampaignMemberId: {
          value: this.userID,
        },
      };
      return this.$http({
        method: 'put',
        url: `${this.apiUrl}/campaign/events/event`,
        headers: {
          Authorization: `${this.getCookieValue('Authorization')}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(payload),
      })
        .then(this.checkForRegistrationStatus)
        .catch(this.handleRegistrationError)
        .finally(this.finishSubmitting);
    },
    redirectToLogin() {
      localStorage.setItem('redirectToolData', JSON.stringify({
        tenant: document.body.dataset.tenant,
        dataRedirecturlAfterLogin: window.location.href,
      }));
      window.location = this.landingpageUrl;
    },
    placeholder(field) {
      return field.required ? `${field.label} *` : `${field.label}`;
    },
  },
  async created() {
    if (this.translations) {
      this.addDictionary(this.translations);
    }
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('campaignID')) {
      this.hasCampaignIDParam = true;
      const campaignID = urlParams.get('campaignID');
      const urlParam = campaignID;

      const responseBaseinfo = await this.getEventData(
        `${this.apiUrl}/campaign/events/event/baseinfo/${urlParam}`,
      );

      await this.initIsEventFullyBooked(this.apiUrl, urlParam);

      if (responseBaseinfo && responseBaseinfo.data) {
        this.event = this.renameObjectKeys(responseBaseinfo.data.info);
      }

      this.event = this.getEventWithAdditionalContentFor(this.event);

      if (this.isLoggedIn) {
        this.prefillFieldsWithUserData();
        this.$nextTick(() => {
          this.validateForm();
        });
        const responseParticipating = await this.getEventsParticipating();

        this.alreadyRegistered = responseParticipating.data.info.Campaigns.some(
          (campaign) => campaign.Id === `${campaignID}`,
        );
        if (this.alreadyRegistered) {
          const currentUserMyUserId = responseParticipating?.data?.info?.myUser_ID__c ?? '';
          const eventCampaignMembers = responseParticipating?.data?.info?.Campaigns?.find((event) => event.Id === this.event.id)?.CampaignMembers ?? [];
          const currentUserCampaignMemberObject = eventCampaignMembers.find((member) => member.myUser_ID__c === currentUserMyUserId);

          this.userID = currentUserCampaignMemberObject?.Id ?? '';
          this.isCurrentUserStatusCanceled = currentUserCampaignMemberObject?.EventRegistrationStatus__c === 'Registration cancelled';
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
select {
  &:focus:invalid {
    border: 1px solid #cc3333 !important;
    outline: 0 solid #cc3333 !important;
    color: #cc3333 !important;
  }
}
</style>
